var map = {
	"./logo0.png": 3168,
	"./logo1.png": 9417,
	"./logo10.png": 9869,
	"./logo11.png": 6836,
	"./logo12.png": 1327,
	"./logo2.png": 6482,
	"./logo3.png": 6987,
	"./logo4.png": 7076,
	"./logo5.png": 8205,
	"./logo6.png": 6998,
	"./logo7.png": 8543,
	"./logo8.png": 7384,
	"./logo9.png": 8513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5423;